import { NgStyle } from '@angular/common';
import { Component, ChangeDetectionStrategy, input, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ThemePipe } from 'src/app/core/pipes/theme.pipe';

@Component({
  selector: 'app-tutorial-versus-content',
  templateUrl: './tutorial-versus-content.component.html',
  styleUrls: ['./tutorial-versus-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe],
})
export class TutorialVersusContentComponent {
  imageUrl = input.required<string | null>();
  description = input.required<string>();
  labelBottom = input('10%');

  private translocoService = inject(TranslocoService);

  readonly contentStyles: [string, string][] = [
    ['type', 'drawer-tutorial-graphic-text'],
    ['text-color', 'drawer-tutorial-graphic-text'],
  ];

  readonly descriptionStyles: [string, string][] = [
    ['type', 'drawer-tutorial-body'],
    ['text-color', 'drawer-tutorial-body'],
  ];

  readonly youLabel = this.translocoService.translate('components.tutorial-wizard.you');
  readonly opponentLabel = this.translocoService.translate('components.tutorial-wizard.opponent');
}
